module.exports = __webpack_public_path__ + "img/chart.51a0bf9c.svg";